module.exports = __webpack_public_path__ + "static/copic_CMYK-691df31c26ac0169ec909cec9163596c.svg";